import {Routes} from '@angular/router';
import { AuthGuard } from './guards/auth.guard';

export const routes: Routes = [
    {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    loadComponent: () => import("./features/home/pages/home.component").then(c => c.HomeComponent),
    canActivate: [AuthGuard],
    canMatch: [AuthGuard]
  },
  {
    path: 'studies',
    loadComponent: () => import("./features/studies/pages/studies-list/studies-list.component").then(c => c.StudiesListComponent),
    canActivate: [AuthGuard],
    canMatch: [AuthGuard]
  },
  {
    path: 'studyProjections',
    loadComponent: () => import("./features/study-projections/pages/study-projection-list/study-projection-list.component").then(c => c.StudyProjectionListComponent),
    canActivate: [AuthGuard],
    canMatch: [AuthGuard]
  },
  {
    path: 'materials',
    loadComponent: () => import("./features/materials/pages/material-list/material-list.component").then(c => c.MaterialListComponent),
    canActivate: [AuthGuard],
    canMatch: [AuthGuard]
  },
  {
    path: 'studyConfigs',
    loadComponent: () => import("./features/study-config/pages/study-config-list/study-config-list.component").then(c => c.StudyConfigListComponent),
    canActivate: [AuthGuard],
    canMatch: [AuthGuard]
  },
  {
    path: 'studySells',
    loadComponent: () => import("./features/study-customer-sell/pages/study-customer-sell-list/study-customer-sell-list.component").then(c => c.StudyCustomerSellListComponent),
    canActivate: [AuthGuard],
    canMatch: [AuthGuard]
  },
  {
    path: 'customers',
    loadComponent: () => import("./features/customers/pages/customer-list/customer-list.component").then(c => c.CustomerListComponent),
    canActivate: [AuthGuard],
    canMatch: [AuthGuard]
  },
  {
    path: 'dashboard',
    loadComponent: () => import("./features/dashboard/pages/dashboard-charts/dashboard-charts.component").then(c => c.DashboardChartsComponent),
    canActivate: [AuthGuard],
    canMatch: [AuthGuard]
  },
  {
    path: 'configuration',
    loadComponent: () => import("./features/unimagen-config/pages/system-config/system-config.component").then(c => c.SystemConfigComponent),
    canActivate: [AuthGuard],
    canMatch: [AuthGuard]
  },
  {
    path: '**',
    redirectTo: 'home'
  }
];
